export default __webpack_public_path__ + "static/media/37cd85e0-d6b3-4191-8cd6-b63e531731ef.88ddbec8.jpeg";